import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { Observable } from 'rxjs';
import { CaldavDTO, CaldavWriteDTO } from '../interfaces/calDav';

@Injectable({
  providedIn: 'root'
})
export class CaldavService {

  constructor(private dataService: DataService) { }

  saveCaldav(caldavId: number, caldav: CaldavWriteDTO): Observable<CaldavDTO> {
    if (caldavId && caldavId > 0) {
      return this.dataService.updateCaldav(caldavId, caldav);
    } else {
      return this.dataService.createCaldav(caldav);
    }
  }

  deleteCaldav(caldav: CaldavDTO) {
    if (!caldav || caldav.id == null || caldav.id == undefined || caldav.id < 1) {
      return this.dataService.deleteCaldav(caldav.id);
    } else return null;
  }

  getCaldavs(): Observable<any> {
    return this.dataService.getCaldavs();
  }

  getCaldav(calDavId: number): Observable<any> {
    return this.dataService.getCaldav(calDavId);
  }

  testCaldavAccount(caldav: CaldavWriteDTO): Observable<any> {
    return this.dataService.testCaldavAccount(caldav);
  }

  discoverCalDavCalendars(calDav: CaldavWriteDTO) {
    return this.dataService.discoverCalDavCalendars(calDav);
  }

  updateCaldavPassword(id: number, password: string) {
    return this.dataService.updateCaldavPassword(id, password);
  }
}
